// extracted by mini-css-extract-plugin
module.exports = {"paper":"wrongAppVersion_paper__wK7HL","reloadButton":"wrongAppVersion_reloadButton__AqfHu"};